/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { Form, Input, Checkbox } from 'antd';
import T from 'i18n-react';
import { Box, Typography } from '@material-ui/core';
import { selectLoading, selectError, selectAttribute } from 'shared/selectors';
import { userVerification } from 'views/Registration/actions';
import { actLogout } from 'actions/loginStateActions';
import Notification from 'components/Notification';
import { ALI_REGISTRATION_PATH, FEDEX_PATH } from 'shared/routes';
import { checkIfAdmin, getRoleId, isLogin } from 'store/selectors/loginState';
import { actLogin, actLoginInit, unLocked, userSocialLogin } from 'views/Login/actions';
import { ReactComponent as ICWLogo } from 'assets/icons/walmart/icw_logo.svg';
import WalmartLogo from 'assets/icons/walmart/logo.png';
import { LOCKED_LOGIN_TIME } from 'shared/constants';
import { getLSItem } from 'util/localStorageProvider';
import { AInput, AButton } from 'components/Antd';
import classes from './Login.module.scss';

const LoginComponent = ({ onLogin, onInit, location, hasToken, onLogout,
  onActivateUser, loginLoading, unLocked, loginError, loginLocked, isUserLogin,
  history, isAdmin, roleId }) => {
  const [focusInput, setFocusInput] = useState(false);
  const [notification, setNotification] = useState({ type: null, message: null });
  const lockedStorage = getLSItem('lockedLogin');
  const lockedTimeStorage = parseInt(getLSItem('lockedLoginTime') || 0, 10);
  const nowTime = new Date().getTime();
  const isLockedStorage = lockedStorage === 'true' && nowTime - lockedTimeStorage < LOCKED_LOGIN_TIME;
  const handleActivateSuccessfully = () =>
    setNotification({
      type: 'green_success',
      message: 'Activate user successfully',
    });
  const handleActivateFailed = () =>
    setNotification({
      type: 'error',
      message: 'Activate user failed',
    });
  const activateUser = () => {
    const params = queryString.parse(location?.search);
    const { token, companyId } = params;

    if (token && companyId) {
      // if user logged in, need to logout first
      if (hasToken) {
        onLogout();
      }
      onActivateUser({ token, companyId }, handleActivateSuccessfully, handleActivateFailed);
    }
  };
  const isUserLoginDOM = () => {
    const params = queryString.parse(location.search);
    const { action } = params;

    if (isAdmin) {
      if (roleId === 3) {
        // eslint-disable-next-line no-undef
        return (window.location.href = '/icw_admin');
      }
      // eslint-disable-next-line no-undef
      return (window.location.href = '/admin_panel');

      // eslint-disable-next-line no-undef
    }
    if (params.redirect) {
      window.location.href = params.redirect;
    } else {
      if (action && action === 'fedex') {
        return <Redirect to={FEDEX_PATH} />;
      }
      return <Redirect to='/' />;
    }
  };

  useEffect(() => {
    if (isUserLogin) {
      history.replace('/');
    }
    onInit()
    activateUser()
  }, [])
  useEffect(() => {
    let unLockedTimeout = null;
    if (!loginLoading) {
      setFocusInput(false);
      if (loginLocked) {
        unLockedTimeout = setTimeout(() => {
          unLocked();
        }, 15 * 1000 * 60);
      }
    }
    return () => {
      if (unLockedTimeout) {
        clearTimeout(unLockedTimeout);
      }
    };

    // eslint-disable-next-line
  }, [loginLoading]);
  
  return isUserLogin ? (<>{isUserLoginDOM()}</>) : (
    <div className={classes.wrapper}>
      <div className={classes.inner}>
        <Form
          name="walmart-login"
          initialValues={{ remember: true, email: '', password: '' }}
          onFinish={values => {
            if (values.remember && !isLockedStorage) {
              onLogin(values.email, values.password, null, true);
            }
          }}
          autoComplete="off"
          className={classes.form}
          layout="vertical"
        >
          <img src={WalmartLogo} alt="walmart" className={classes.walmartLogo} />
          <span className={classes.subHeading}>eCommerce Merchandise Compliance Check Platform</span>
          <Form.Item
            label={<><span className={classes.required}>*</span><span>Email</span></>}
            name="email"
            rules={[{ required: true, message: 'The email is not valid' }]}
          >
            <AInput size="large" className={classes.emailInput} />
          </Form.Item>

          <Form.Item
            label={<><span className={classes.required}>*</span><span>Password</span></>}
            name="password"
            rules={[{ required: true, message: 'Please input your password' }]}
          >
            <Input.Password size="large" className={classes.passwordInput} />
          </Form.Item>

          <Form.Item
            name="remember"
            valuePropName="checked"
          >
            <Checkbox><span>I agree to the <a href="https://www.icw.io/terms-conditions/" target="_blank" rel="noreferrer">Terms &amp; Conditions</a> , <a href="https://www.icw.io/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a> , and <a href="https://www.icw.io/cookie-policy/" target="_blank" rel="noreferrer">Cookie Policy.</a></span></Checkbox>
          </Form.Item>
          {(loginLocked || isLockedStorage) && (
            <Box>
              <Typography
                variant='caption'
                display='block'
                align='left'
                color='error'
                className={classes.firstParam}>
                  Looks like you are having trouble signing in.
              </Typography>
              <Typography variant='caption' display='block' align='left' color='error'>
                Please wait 15 minutes before trying again or try resetting your password.
              </Typography>
            </Box>
          )}
          <Form.Item>
            <AButton type="primary" htmlType="submit" size="large" loading={loginLoading}>
              Login
            </AButton>
          </Form.Item>
          <div className={classes.forgotPassword}>
            <span>
              Forgot Password?
            </span>
          </div>
          {loginError && !loginLocked && !focusInput && (
            <Box mt='20px'>
              <Typography variant='caption' display='block' align='center' color='error'>
                Incorrect email address or password. Please try again
              </Typography>
            </Box>
          )}
        </Form>
        <div className={classes.footer}>
          <span>Powered by</span>
          <ICWLogo />
        </div>
      </div>
      <Notification
        notification={notification}
        onClose={() => setNotification({ type: null, message: null })}
      />
    </div>
  )
}

const mapStateToProps = (state, { cookies }) => {
  return {
    status: state.loginState.status,
    isUserLogin: isLogin(state) && !!cookies.get('token'),
    isAdmin: checkIfAdmin(state),
    roleId: getRoleId(state),
    loginLocked: selectAttribute('loginReducer', 'login.error.locked', false)(state),
    loginLoading: selectLoading('loginReducer', 'login')(state),
    loginError: selectError('loginReducer', 'login')(state),
    hasToken: !!cookies.get('token'),
  };
};

const mapDispatchToProps = (dispatch, { cookies }) => ({
  onInit: bindActionCreators(actLoginInit, dispatch),
  onLogin: bindActionCreators(actLogin, dispatch),
  unLocked: bindActionCreators(unLocked, dispatch),
  onSocialLogin: bindActionCreators(userSocialLogin, dispatch),
  onActivateUser: bindActionCreators(userVerification, dispatch),
  onLogout: () => dispatch(actLogout(cookies)),
});

const Login = withCookies(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent)));

export default Login;
